import { useCallback } from 'react';

import useGlobalModals from '~/components/GlobalModals/hooks/useGlobalModals';

// The intent travels through the URL, so the layout renders `AnswerQuestionModal` for it.
export const useOpenAnswerQuestionModal = () => {
  const { handleOpenModal } = useGlobalModals();

  return useCallback(
    (spaceId: string) => {
      handleOpenModal('community_answer_question', { preventScrollReset: true }, { space_id: spaceId });
    },
    [handleOpenModal],
  );
};
